import Spark from 'actions/spark';

export default Spark.createReducer();
